<template>
  <ion-page>
    <ion-content class="ion-padding-bottom" color="light">
      <logo-header />
      <login-form
        :submitHandler="onSubmit"
        :loading="loading"
        :errorTxt="errorTxt"
        class="ion-padding-vertical"
      />
    </ion-content>
    <ion-footer>
      <ion-progress-bar v-if="loading" type="indeterminate"></ion-progress-bar>
      <gbp-footer />
    </ion-footer>
  </ion-page>
</template>

<script lang="ts">
import LoginForm from "@/components/admin/LoginForm.vue";
import { IonContent, IonFooter, IonPage } from "@ionic/vue";
import { defineComponent, ref } from "vue";
import LogoHeader from "../components/LogoHeader.vue";
import GbpFooter from "@/components/Footer.vue";

export default defineComponent({
  name: "LoginPage",
  components: {
    IonContent,
    IonFooter,
    IonPage,
    LogoHeader,
    LoginForm,
    GbpFooter,
  },
  setup() {
    const loading = ref(false);
    const errorTxt = ref("");
    return {
      loading,
      errorTxt,
    };
  },
  mounted() {
    this.$store.dispatch("initFromStorage");
  },
  methods: {
    async onSubmit(values: { username: string; password: string }) {
      this.loading = true;
      const errorMsg = await this.$store.dispatch("login", {
        email: values.username,
        password: values.password,
      });
      if (errorMsg && errorMsg.length) {
        this.errorTxt = errorMsg;
        setTimeout(() => {
          this.errorTxt = "";
          this.loading = false;
        }, 3000);
      } else {
        setTimeout(() => {
          this.loading = false;
          this.$router.push("/dashboard");
        }, 1000);
      }
    },
  },
});
</script>